/* global axios */
import ApiClient from './ApiClient';

// Account-scoped channel hosting (linked-device) sessions API.
class ChannelHostingAPI extends ApiClient {
  constructor() {
    super('channel_hosting_sessions', { accountScoped: true });
  }

  getQuota() {
    return axios.get(`${this.url}/quota`);
  }

  checkProxy(data) {
    return axios.post(`${this.url}/check_proxy`, data);
  }

  getSessions() {
    return axios.get(this.url);
  }

  createSession(data) {
    return axios.post(this.url, data);
  }

  getSession(id) {
    return axios.get(`${this.url}/${id}`);
  }

  refresh(id) {
    return axios.post(`${this.url}/${id}/refresh`);
  }

  updateProxy(id, data) {
    return axios.patch(`${this.url}/${id}/update_proxy`, data);
  }

  reconnect(id) {
    return axios.post(`${this.url}/${id}/reconnect`);
  }

  disconnect(id) {
    return axios.post(`${this.url}/${id}/disconnect`);
  }

  deleteSession(id, { deleteInbox = false } = {}) {
    return axios.delete(`${this.url}/${id}`, {
      params: { delete_inbox: deleteInbox },
    });
  }
}

export default new ChannelHostingAPI();
